import { render, staticRenderFns } from "./NovoTurno.vue?vue&type=template&id=40bbfcae&scoped=true"
import script from "./NovoTurno.vue?vue&type=script&lang=js"
export * from "./NovoTurno.vue?vue&type=script&lang=js"
import style0 from "./NovoTurno.vue?vue&type=style&index=0&id=40bbfcae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bbfcae",
  null
  
)

export default component.exports